import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SrpSmBox from './SrpSmBox';
import SrpMdBox from './SrpMdBox';


const SrpList = ({ filteredVehicleData, numberFormatter, priceFormatter, isMobile }) => {

    const openVDP = (vdp_url) => {
        console.log("vdp_url", vdp_url)
        window.location.href = "/vehicle-details/" + vdp_url;
    }
    const latestDropIndices = filteredVehicleData && filteredVehicleData
        .map((item, idx) => item?.inventory_manage.latest_drop ? idx : -1)
        .filter(idx => idx !== -1);
    const allowedDropIndex =
        latestDropIndices.length === 1
            ? latestDropIndices[0]
            : latestDropIndices.length > 1
                ? latestDropIndices[1]
                : null;

    const allowedDropSet = new Set(allowedDropIndex !== null ? [allowedDropIndex] : []);
    return (
        <>
            <section className='srp-list-wrap pt-3'>
                <div className='container'>
                    <div className='srp-block'>
                        <div className='row'>
                            {filteredVehicleData && filteredVehicleData.map((item, index, array) => {
                                const adjustedIndex = index + 1;
                                const isAllowedDrop = item?.inventory_manage.latest_drop ? allowedDropSet.has(index) : true;
                                //console.log(item,adjustedIndex);
                                if (isMobile) {
                                    return (
                                        <React.Fragment key={index}>
                                            <SrpSmBox
                                                item={item}
                                                index={index}
                                                priceFormatter={priceFormatter}
                                                numberFormatter={numberFormatter}
                                            />
                                        </React.Fragment>
                                    );
                                }
                                if (item?.inventory_manage.latest_drop && adjustedIndex % 3 === 0) {

                                    return (
                                        <React.Fragment key={index}>
                                            <SrpSmBox
                                                item={item}
                                                index={index}
                                                priceFormatter={priceFormatter}
                                                numberFormatter={numberFormatter}
                                            />
                                            {adjustedIndex < array.length && isAllowedDrop && (
                                                <>
                                                <SrpMdBox
                                                    item={item}
                                                    index={index}
                                                    priceFormatter={priceFormatter}
                                                    numberFormatter={numberFormatter}
                                                />
                                                </>
                                            )}
                                        </React.Fragment>
                                    );
                                //} else if ((adjustedIndex - 1) % 3 === 0 && array[adjustedIndex - 2]?.latest_drop) {
                                    // Skip rendering `Box 1` since it was rendered at the next adjustedIndex
                                //    return null;
                                } else {
                                    return (
                                        <React.Fragment key={index}>
                                            {item?.inventory_manage.latest_drop && isAllowedDrop ? (
                                                <>
                                                <SrpMdBox
                                                    item={item}
                                                    index={index}
                                                    numberFormatter={numberFormatter}
                                                    priceFormatter={priceFormatter}
                                                    adjustedIndex={adjustedIndex}
                                                />
                                                </>
                                            ) : (
                                                <SrpSmBox
                                                    item={item}
                                                    index={index}
                                                    priceFormatter={priceFormatter}
                                                    numberFormatter={numberFormatter}
                                                />
                                            )}
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SrpList